import { extendTheme } from "@chakra-ui/react";

import { AccordionTheme } from "./components/accordion-theme";
import { BadgeTheme } from "./components/badge-theme";
import { ButtonTheme } from "./components/buttons-theme";
import { CheckboxTheme } from "./components/checkbox-theme";
import { FormTheme } from "./components/form-theme";
import { FormLabelTheme } from "./components/formlabel-theme";
import { HeadingTheme } from "./components/heading-theme";
import { InputTheme } from "./components/input-theme";
import { ModalTheme } from "./components/modal-theme";
import { NumberInputTheme } from "./components/number-input-theme";
import { PopoverTheme } from "./components/popover-theme";
import { RadioTheme } from "./components/radio-theme";
import { SelectTheme } from "./components/select-theme";
import { SwitchTheme } from "./components/switch-theme";
import { TabTheme } from "./components/tab-theme";
import { TableTheme } from "./components/table-theme";
import { TextTheme } from "./components/text-theme";
import { TagTheme } from "./components/tag-theme";

export const theme = extendTheme({
  fonts: {
    heading: `'Gotham', Arial, 'open-sans', sans-serif`,
    body: `'Gotham', Arial, 'open-sans', sans-serif`,
  },
  textStyles: {
    h1: {
      fontSize: "2rem",
    },
    p: {
      textAlign: "justify",
    },
  },
  styles: {
    global: {
      body: { overflowY: "hidden" },
      "::-webkit-scrollbar": {
        width: 2,
        height: 2,
        backgroundColor: "brand.gray.90",
        borderRadius: "1000px",
      },
      "::-webkit-scrollbar-thumb": {
        backgroundColor: "brand.gray.110",
        borderRadius: "1000px",
      },
      "::-webkit-scrollbar-track": {},
      "::selection": {
        color: "white",
        backgroundColor: "brand.red.100",
      },
    },
  },
  colors: {
    brand: {
      red: {
        "10": "rgba(210, 0, 25, 0.1)",
        "50": "#e87f8b",
        "100": "#d20019",
        "110": "#bc0016",
      },
      black: {
        "90": "#191919",
        "100": "#000000",
      },
      white: {
        "100": "#ffffff",
      },
      gray: {
        "90": "#f8f8f8",
        "100": "#f3f2f1",
        "110": "#e1e1e1",
        "120": "#969696",
      },
      orange: {
        "100": "#f57d37",
      },
      orangered: {
        "100": "#ff5541",
      },
      skyblue: {
        "10": "rgba(0, 200, 245, 0.1)",
        "100": "#00c8f5",
        "120": "#E0F8FE",
      },
      royalblue: {
        "100": "#008cbe",
      },
      darkblue: {
        "100": "#003c5f",
      },
    },
    labels: {
      G: "#DE3822",
      F: "#E67219",
      E: "#F4B70F",
      D: "#F7D707",
      C: "#BAD418",
      B: "#58AE38",
      A: "#3C9F2D",
      "A+": "#399A44",
      "A++": "#31852B",
      "A+++": "#2B7510",
      "A++++": "#24620E",
    },
  },
  components: {
    Accordion: AccordionTheme,
    Badge: BadgeTheme,
    Button: ButtonTheme,
    Checkbox: CheckboxTheme,
    Form: FormTheme,
    FormLabel: FormLabelTheme,
    Heading: HeadingTheme,
    Input: InputTheme,
    Modal: ModalTheme,
    NumberInput: NumberInputTheme,
    Popover: PopoverTheme,
    Radio: RadioTheme,
    Select: SelectTheme,
    Switch: SwitchTheme,
    Table: TableTheme,
    Tabs: TabTheme,
    Text: TextTheme,
    Tag: TagTheme
  },
});
